export const SIZE_GUIDE_CONTENT = {
  title: 'Size Guide',
  subtitle: 'Find the perfect friend size.',
  breadcrumb: 'Size Guide',
  chart: {
    title: 'Size Chart',
    heightLabel: 'Height',
    categoryHeader: 'Category',
    heightHeader: 'Height',
    ageHeader: 'Ages',
    useCaseHeader: 'Best For',
  },
  sizes: [
    {
      name: 'Small',
      icon: 'Smile',
      height: '20-30cm',
      age: '0+',
      bestFor: 'Toddlers',
      examples: 'Mini Bear',
    },
    {
      name: 'Medium',
      icon: 'Heart',
      height: '40-50cm',
      age: '3+',
      bestFor: 'Hugging',
      examples: 'Classic Bear',
    },
    {
      name: 'Large',
      icon: 'Star',
      height: '60cm+',
      age: '3+',
      bestFor: 'Decor',
      examples: 'Jumbo Bear',
    },
  ],
  tipsSection: {
    title: 'Pro Tips',
    description: 'Some helpful tips for finding the perfect friend.',
    tips: [
      'Consider the age of the recipient',
      'Think about where the friend will live',
      'Check the materials for allergies',
    ],
  },
  categories: [
    { id: 'small', title: 'Small (20-30cm)', desc: 'Perfect for first friends.' },
    { id: 'medium', title: 'Medium (40-50cm)', desc: 'Great for hugging.' },
    { id: 'large', title: 'Large (60cm+)', desc: 'Perfect statement pieces.' },
  ],
} as const;
